import _Popup from "@kibt/meta-ui/es/popup";
import { defineComponent } from '@vue/composition-api';
import dayjs from 'dayjs';
import useStore from '../store';
export default defineComponent({
  components: {
    MPopup: _Popup
  },
  model: {
    event: 'change',
    prop: 'visible'
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change', 'to-post'],
  setup: function setup(props, ctx) {
    var store = useStore();

    var formateTime = function formateTime(time) {
      return dayjs(time).format("".concat(ctx.root.$k18n({
        id: 'creator_month_day'
      }), " mm:ss"));
    };

    return {
      store: store,
      formateTime: formateTime
    };
  }
});